export default [
  {
    heading: 'common.credits',
    description: 'widget.home_page.services.credits.description',
    image: '/images/photostock/guy-credit-242x243.avif',
    url: '/credits'
  },
  {
    heading: 'common.payment_cards',
    description: 'widget.home_page.services.cards.description',
    url: '/cards',
    icon: 'credit-card'
  },
  {
    heading: 'common.money_transfers',
    description: 'widget.home_page.services.money_transfers.description',
    url: '/money-transfers',
    icon: 'money-transfers'
  },
  {
    heading: 'common.insurance',
    description: 'widget.home_page.services.insurances.description',
    url: '/insurances',
    icon: 'shield-check'
  },
  {
    heading: 'common.exchange_rates',
    description: 'widget.home_page.services.rates.description',
    url: '/rates',
    icon: 'refresh-ccw'
  },
  {
    heading: 'widget.home_page.services.microcredit.heading',
    description: 'widget.home_page.services.microcredit.description',
    url: '/microcredit',
    image: '/images/photostock/guy-microcredit-242x243.avif'
  },
  {
    heading: 'widget.home_page.services.deposits.heading',
    description: 'widget.home_page.services.deposits.description',
    url: '/deposits',
    icon: 'capitalization'
  },
  {
    heading: 'common.islamic_finance',
    description: 'widget.home_page.services.islamic.description',
    url: '/deposits/islamic',
    icon: 'islamic',
    badge: 'widget.home_page.services.islamic.badge'
  },
  {
    heading: 'common.crypto',
    description: 'widget.home_page.services.crypto.description',
    url: '/crypto-companies',
    icon: 'bitcoin'
  },
  {
    heading: 'widget.home_page.services.useful_articles.heading',
    description: 'widget.home_page.services.useful_articles.description',
    url: '/useful-articles',
    icon: 'message-square'
  }
]
